module.exports = "//static.hsappstatic.net/connect-dot-com-ui/static-1.468/img/logo/connect-full-logo-white.svg"